import { Flex, Typography, Button, Icons } from 'components';
import { ReactElement, useCallback } from 'react';
import styled from 'styled-components';
import AuthenticatorAppSvg from 'app/images/authenticatorapp.svg';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { FormTokenItem } from 'features/mfa';
import { FormErrorMessage, FormInput } from 'features/mfa/styles';

const AuthenticatorApp = styled('div')`
  background: url(${AuthenticatorAppSvg});
  background-size: cover;
  background-position: center;
  ${({ theme: { mediaQueries } }) => {
    return `
   
        width: 300px;
        height:100px;
      
    
    ${mediaQueries.desktop} {
        width: 560px;
         height:264px;
      }

      
    `;
  }}
`;
interface TokenConfimationProps {
  onClick: (value: string) => void;
  onClickLink?: () => void;
  isLogin?: boolean;
}
const Icon = styled(Icons)`
  width: 24px;
  height: 24px;
  color: ${({ theme }) => theme.colors.gray_300};
  margin-right: 8px;
`;

const schema = yup
  .object()
  .shape({
    mfacode: yup.string().required('Você precisa informar o token'),
  })
  .required();

const TokenConfimation = ({ onClick, isLogin = false, onClickLink }: TokenConfimationProps): ReactElement => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      mfacode: '',
    },
  });

  const onSubmit = useCallback((receivedData: FormTokenItem) => {
    if (receivedData) {
      onClick(receivedData.mfacode);
    }
  }, []);

  return (
    <Flex alignSelf="center" flexDirection="column" padding={20} maxWidth={600} backgroundColor="white">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Flex justifyContent="center">
          <Flex marginBottom={16} justifyContent="center">
            <Typography fontWeight="bold" color="dark_350" textAlign="center">
              Digite o código que aparece no seu app autenticador
            </Typography>
          </Flex>
          <Flex maxWidth={530} justifyContent="center">
            <Flex marginBottom={32} justifyContent="center">
              <Typography type="type1" color="dark_350" textAlign="center">
                Confirme o código de 6 dígitos que aparece para a MELVER em seu aplicativo
              </Typography>
            </Flex>
          </Flex>
          <Flex alignSelf="flex-start" flexDirection="column">
            <Typography type="type1" fontWeight="bold" color="dark_350">
              Exemplo
            </Typography>
            <Flex overflow="hidden" mt="10px">
              <AuthenticatorApp />
            </Flex>
            <Flex marginTop={32}>
              <Typography type="type1" fontWeight="bold" color="dark_350">
                Código de confirmação
              </Typography>
              <FormInput
                placeholder="000000"
                {...register('mfacode')}
                style={{ height: 70, fontSize: 20, width: '100%', marginTop: 5 }}
                data-error={errors?.mfacode?.message}
                autoFocus={true}
              />
              {errors?.mfacode?.message ? <FormErrorMessage>{errors?.mfacode?.message}</FormErrorMessage> : null}
            </Flex>
          </Flex>

          <Flex marginBottom={32} marginTop={32} flexDirection="row" justifyContent="space-between" alignItems="center">
            <Flex>
              <Icon icon="info" />
            </Flex>

            <Flex maxWidth={500}>
              <Typography type="type1" color="light4">
                A MELVER nunca solicita códigos por telefone ou aplicativos de mensagem. Não compartilhe seu código com outras pessoas.
              </Typography>
            </Flex>
          </Flex>
        </Flex>

        <Flex flexDirection="row" justifyContent={isLogin ? 'space-between' : 'center'} alignItems="center">
          <Button minWidth={197} type="submit" p={24} bg="primary_400" color="white" colorHover="white" size="small">
            Confirmar código
          </Button>
          {isLogin ? (
            <Button
              outline
              bg="transparent"
              size="small"
              color="primary_400"
              onClick={() => onClickLink && onClickLink()}
              style={{ textTransform: 'inherit', fontWeight: 'normal', border: 0 }}
            >
              Acessar com código de recuperação
            </Button>
          ) : null}
        </Flex>
      </form>
    </Flex>
  );
};

export default TokenConfimation;
